import { noop } from '@frontend/utils';

import {
  type FindingData,
  toFindingData,
  toFindingDataFromFieldSuggestion,
  toFindingDataFromTextSnippet,
} from 'modules/common/components/findings';

import type { ISuggestionAnnotation } from '../annotationCommands/SuggestionAnnotation';
import {
  ANNOTATION_METADATA_TYPES,
  type ActionExtractionTextMetadata,
  type FieldSuggestionMetadata,
  type FoundInFileMetadata,
} from '../annotationCommands/types';

/**
 * Bridge ISuggestionAnnotation metadata → FindingData.
 */
export const annotationToFindingData = (
  annotation: ISuggestionAnnotation,
): FindingData | null => {
  const metadata = annotation.rawAnnotation?.metadata;

  switch (metadata?.type) {
    case ANNOTATION_METADATA_TYPES.FOUND_IN_FILES: {
      const { partBotResult } = metadata as FoundInFileMetadata;
      return toFindingData(partBotResult);
    }

    case ANNOTATION_METADATA_TYPES.FIELD_SUGGESTION: {
      const { fieldSuggestion } = metadata as FieldSuggestionMetadata;
      return toFindingDataFromFieldSuggestion(
        {
          suggestion: fieldSuggestion.suggestion,
          sourceName: fieldSuggestion.sourceName,
          sourcePartFileId: fieldSuggestion.sourcePartFileId,
          id: fieldSuggestion.id,
        },
        annotation.getPageNumber?.(),
      );
    }

    case ANNOTATION_METADATA_TYPES.ACTION_EXTRACTION_TEXT: {
      const { textPositionResult } = metadata as ActionExtractionTextMetadata;
      return toFindingDataFromTextSnippet({
        snippet: textPositionResult.snippet,
        filename: '',
        onFileClick: noop,
      });
    }

    case ANNOTATION_METADATA_TYPES.EXTRACTED_TABLE:
    default:
      return null;
  }
};
